'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateUniqueClientTimestamp = generateUniqueClientTimestamp;
function generateUniqueClientTimestamp() {
  var namespace = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'default';

  var now = Date.now();

  var previousTimestamps = generateUniqueClientTimestamp.previousTimestamps;


  if (previousTimestamps && previousTimestamps[namespace] >= now) {
    previousTimestamps[namespace]++;
    return previousTimestamps[namespace];
  }

  previousTimestamps[namespace] = now;
  return now;
}

generateUniqueClientTimestamp.previousTimestamps = {};

generateUniqueClientTimestamp.reset = function reset() {
  this.previousTimestamps = {};
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/lib/timestamps.js
// module id = 122
// module chunks = 2 3